<div class="modal">
    <div class="header">
        <ng-container *ngIf="(checkContentFileError$ | async)">
            <h1 class="title">{{'IMPORT_MEMBERS_CONTENT_CSV_ERROR_TITLE' | translate}}</h1>
        </ng-container>
        <ng-container *ngIf="(importMembersError$ | async)">
            <h1 class="title">{{'IMPORT_MEMBERS_IMPORT_ERROR_TITLE' | translate}}</h1>
        </ng-container>
        <ng-container *ngIf="!(importMembersError$ | async) && !(checkContentFileError$ | async) && !(importMembersSuccess$ | async)">
            <h1 class="title">{{'PREMIUM_ADMIN_MEMBER_MODAL_IMPORT_MEMBERS_TITLE' | translate}}</h1>
        </ng-container>
        <ng-container *ngIf="(importMembersSuccess$ | async)">
            <h1 class="title">{{'PREMIUM_ADMIN_MEMBER_MODAL_IMPORT_MEMBERS_TITLE_SUCCESS' | translate}}</h1>
        </ng-container>
    </div>
    <div class="body body-scroll">
        <!-- Body content when import is started -->
        <ng-container *ngIf="(importCSVProcessing$ | async); else importNotStarted">
            <!-- When checking CSV content -->
            <ng-container *ngIf="(checkContentFileProcessing$ | async)">
                <ng-container *ngTemplateOutlet="checkingContentFile"></ng-container>
            </ng-container>
            <!-- When error while checking CSV -->
            <ng-container *ngIf="(checkContentFileError$ | async)">
                <ng-container *ngTemplateOutlet="contentFileError"></ng-container>
            </ng-container>
            <!-- When importing members -->
            <ng-container *ngIf="(importMembersProcessing$ | async)">
                <ng-container *ngTemplateOutlet="importingMembers"></ng-container>
            </ng-container>
            <ng-container *ngIf="(importMembersError$ | async)">
                <ng-container *ngTemplateOutlet="importError"></ng-container>
            </ng-container>
            <ng-container *ngIf="(importMembersSuccess$ | async)">
                <ng-container *ngTemplateOutlet="importSuccess"></ng-container>
            </ng-container>
        </ng-container>
        <!-- Body content when on file selection -->
        <ng-template #importNotStarted>
            <ng-container *ngTemplateOutlet="fileSelection"></ng-container>
        </ng-template>
    </div>
    <div class="footer">
        <div class="button-wrapper">
            <ng-container *ngIf="(importMembersError$ | async)">
                <button class="btn-new white" (click)="resetEverything()">{{'PREMIUM_ADMIN_MEMBER_MODAL_ADD_MEMBER_BUTTON_LABEL_RETRY' |
                    translate}}</button>
                <button class="btn-new red"
                    (click)="downloadImportErrorReport()">{{'PREMIUM_ADMIN_MEMBER_MODAL_ADD_MEMBER_BUTTON_LABEL_DOWNLOAD_ERROR_REPORT'
                    | translate}}</button>
            </ng-container>
            <ng-container *ngIf="(checkContentFileError$ | async)">
                <button class="btn-new white" (click)="resetEverything()">{{'PREMIUM_ADMIN_MEMBER_MODAL_ADD_MEMBER_BUTTON_LABEL_RETRY' |
                    translate}}</button>
                <button class="btn-new red"
                    (click)="downloadContentFileErrorReport()">{{'PREMIUM_ADMIN_MEMBER_MODAL_ADD_MEMBER_BUTTON_LABEL_DOWNLOAD_ERROR_REPORT'
                    | translate}}</button>
            </ng-container>
            <ng-container *ngIf="(importMembersSuccess$ | async)">
                <button class="btn-new red" (click)="closeModal()">{{'PREMIUM_ADMIN_MEMBER_MODAL_ADD_MEMBER_BUTTON_LABEL_CLOSE_MODAL'
                    | translate}}</button>
                <ng-container *ngIf="(importMembersNonBlockingError$ | async)">
                    <button class="btn-new red"
                        (click)="downloadNonBlockingErrorReport()">{{'PREMIUM_ADMIN_MEMBER_MODAL_ADD_MEMBER_BUTTON_LABEL_DOWNLOAD_ERROR_REPORT'
                        | translate}}</button>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="!(importMembersError$ | async) && !(checkContentFileError$ | async) && !(importMembersSuccess$ | async)">
                <button class="btn-new white" [disabled]="(importCSVProcessing$ | async)"
                    (click)="closeModal()">{{'PREMIUM_ADMIN_MEMBER_MODAL_ADD_MEMBER_BUTTON_LABEL_CANCEL' |
                    translate}}</button>
                <button class="btn-new red" [disabled]="!csvFile || (importCSVProcessing$ | async)"
                    (click)="initImportMembers()">{{'PREMIUM_ADMIN_MEMBER_MODAL_ADD_MEMBER_BUTTON_LABEL_CREATE_MEMBER'
                    | translate}}</button>
            </ng-container>
        </div>
    </div>
</div>

<ng-template #fileSelection>
    <div class="section">
        <div class="section-row">
            <div class="description align-left">{{ 'PREMIUM_ADMIN_MEMBER_MODAL_IMPORT_MEMBERS_TEMPLATE_CSV_EXPLANATION' | translate }}</div>
        </div>
    </div>
    <div class="section">
        <h2 class="title-section">{{ 'PREMIUM_ADMIN_MEMBER_MODAL_IMPORT_MEMBERS_TEMPLATE_CSV_TITLE' | translate }}</h2>
        <div class="section-row">
            <div class="description align-left description-template-csv">{{ 'PREMIUM_ADMIN_MEMBER_MODAL_IMPORT_MEMBERS_TEMPLATE_CSV_DESCRIPTION' | translate
                }}</div>
            <button class="btn-new red button-generate-template" (click)="generateTemplateCSVMembers()">{{
                'PREMIUM_ADMIN_MEMBER_MODAL_IMPORT_MEMBERS_TEMPLATE_CSV_DOWNLOAD' | translate}}</button>
        </div>
        <div class="section-row section-row-example-csv">
            <div class="description align-left description-template-csv">{{
                'PREMIUM_ADMIN_MEMBER_MODAL_IMPORT_MEMBERS_TEMPLATE_CSV_WITH_EXAMPLES_DESCRIPTION' | translate
                }}</div>
            <button class="btn-new red button-generate-template" (click)="generateTemplateCSVWithExamplesMembers()">{{
                'PREMIUM_ADMIN_MEMBER_MODAL_IMPORT_MEMBERS_TEMPLATE_CSV_WITH_EXAMPLES_DOWNLOAD' | translate}}</button>
        </div>
        <div class="section-row warning-message">
            <div class="description align-left">{{'PREMIUM_ADMIN_MEMBER_MODAL_IMPORT_MEMBERS_IMPORT_CSV_WARNING' | translate }}</div>
        </div>
    </div>
    <div class="section">
        <h2 class="title-section">{{ 'PREMIUM_ADMIN_MEMBER_MODAL_IMPORT_MEMBERS_IMPORT_CSV_TITLE' | translate }}</h2>
        <div class="section-column">
            <div class="description align-left">{{ 'PREMIUM_ADMIN_MEMBER_MODAL_IMPORT_MEMBERS_IMPORT_CSV_DESCRIPTION' | translate }}</div>
            <div class="file-container">
                <app-smash-input-file (filesChange)="onFilesChange($event)" [clickEnabled]="false" #inputFile>
                    <div>
                        <div class="file-container-text">{{ 'PREMIUM_ADMIN_MEMBER_MODAL_IMPORT_MEMBERS_DRAG_FILE_PART_1' | translate }}</div>
                        <div class="file-container-text file-container-text-action" (click)="inputFile.openFile()">{{
                            'PREMIUM_ADMIN_MEMBER_MODAL_IMPORT_MEMBERS_DRAG_FILE_PART_2' | translate }}</div>
                    </div>
                </app-smash-input-file>
            </div>
        </div>
    </div>
    <div class="section">
        <h2 class="title-section">{{ 'PREMIUM_ADMIN_MEMBER_MODAL_IMPORT_MEMBERS_TEMPLATE_MAIN_ERRORS_TITLE' | translate }}</h2>
        <div class="section-row">
            <ul class="list-errors">
                <li>{{ 'PREMIUM_ADMIN_MEMBER_MODAL_IMPORT_MEMBERS_TEMPLATE_ERROR_1' | translate }}</li>
                <li>{{ 'PREMIUM_ADMIN_MEMBER_MODAL_IMPORT_MEMBERS_TEMPLATE_ERROR_2' | translate }}</li>
                <li>{{ 'PREMIUM_ADMIN_MEMBER_MODAL_IMPORT_MEMBERS_TEMPLATE_ERROR_3' | translate }}</li>
                <li>{{ 'PREMIUM_ADMIN_MEMBER_MODAL_IMPORT_MEMBERS_TEMPLATE_ERROR_4' | translate }}</li>
                <li>{{ 'PREMIUM_ADMIN_MEMBER_MODAL_IMPORT_MEMBERS_TEMPLATE_ERROR_5' | translate }}</li>
                <li>{{ 'PREMIUM_ADMIN_MEMBER_MODAL_IMPORT_MEMBERS_TEMPLATE_ERROR_6' | translate }}</li>
            </ul>
        </div>
    </div>
</ng-template>

<ng-template #checkingContentFile>
    <div class="section">
        <div class="loading">
            <div class="loading-spinner-grey"></div>
        </div>
        <div>{{ 'IMPORT_MEMBERS_CHECKING_CSV_CONTENT' | translate}}</div>
    </div>
</ng-template>

<ng-template #importingMembers>
    <div class="section">
        <div class="loading">
            <div class="loading-spinner-grey"></div>
        </div>
        <div>{{ 'IMPORT_MEMBERS_IMPORTING_MEMBERS' | translate}} ({{(importedMembers$ |async).length}}/{{(membersToImport$ |async).length}})</div>
        <div>{{ 'IMPORT_MEMBERS_IMPORTING_MEMBERS_WARNING' | translate}}</div>
        <ng-container *ngIf="(importingMembersError$ | async)">
            <div>{{ 'IMPORT_MEMBERS_IMPORTING_MEMBERS' | translate}}</div>
        </ng-container>
    </div>
</ng-template>

<ng-template #contentFileError>
    <div class="section">
        <div>{{ 'IMPORT_MEMBERS_CONTENT_CSV_ERROR_EXPLANATION' |translate}}</div>
    </div>
</ng-template>

<ng-template #importError>
    <div class="section">
        <div>{{ 'IMPORT_MEMBERS_IMPORT_ERROR_EXPLANATION' |translate}}</div>
    </div>
</ng-template>

<ng-template #importSuccess>
    <div class="section">
        <div [translateParams]="{'count':(importedMembers$ | async)?.length}" translate>IMPORT_MEMBERS_IMPORT_SUCCESS</div>
        <ng-container *ngIf=" (importMembersNonBlockingError$ | async)">
            <div>{{ 'IMPORT_MEMBERS_IMPORT_NON_BLOCKIN_ERROR_EXPLANATION' | translate}}</div>
        </ng-container>
    </div>
</ng-template>